import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import TbdNotice from './TbdNotice';
import WitnessTestNotice from './WitnessTestNotice';
import LongBuildNotice from './LongBuildNotice';
import MoveRequestNotice from './MoveRequestNotice';
import ChangeOrderTasksNotice from './ChangeOrderTasksNotice';
import QAFeedback from './QAFeedback';
import { getJobNoticeData } from './utils/noticeUtils';
import { selectChangeOrderDetails } from '../../redux/selectors';
import { hasIncompleteChangeOrderTasks } from './utils/jobHelpers';

const AlertsModal = ({ show, onHide, job, pumpDetails = [], noticeData = null }) => {
  const [showQAFeedback, setShowQAFeedback] = useState(false);
  // Get change order details from Redux
  const changeOrderDetails = useSelector(selectChangeOrderDetails);
  
  // Use provided notice data or generate it
  const notices = noticeData || getJobNoticeData(job, pumpDetails);
  
  // Check if job has incomplete change order tasks
  const hasIncompleteTasksForJob = job ? hasIncompleteChangeOrderTasks(job.ID, changeOrderDetails) : false;
  
  // Determine if we have any notices to show (including change order tasks)
  const hasAnyNotices = notices.hasNotices || hasIncompleteTasksForJob;

  if (!hasAnyNotices) {
    return null;
  }

  return (
    <Modal className="job-schedule-modal" show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="bi bi-exclamation-triangle-fill me-2"></i>
          Job Alerts - {notices.jobInfo?.jobNumber || 'Unknown Job'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {notices.jobInfo?.projectName && (
          <div className="mb-3">
            <strong>Project:</strong> {notices.jobInfo.projectName}
          </div>
        )}
        
        {/* TBD Notice */}
        {notices.notices.tbd?.hasNotice && (
          <TbdNotice jobId={notices.notices.tbd.jobId} />
        )}
        
        {/* Change Order Tasks Notice */}
        {hasIncompleteTasksForJob && job && (
          <ChangeOrderTasksNotice 
            changeOrderDetails={changeOrderDetails} 
            jobId={job.ID}
            projectDetails={job}
          />
        )}
        
        {/* Move Request Notice */}
        {notices.notices.moveRequest?.hasNotice && job && (
          <MoveRequestNotice job={job} />
        )}
        
        {/* Witness Test Notice */}
        {notices.notices.witnessTest?.hasNotice && job && (
          <WitnessTestNotice job={job} />
        )}
        
        {/* Long Build Notice */}
        {notices.notices.longBuild?.hasNotice && job && (
          <LongBuildNotice job={job} pumpDetails={pumpDetails} />
        )}
        
        {/* If no notices are actually rendered, show a message */}
        {!hasAnyNotices && (
          <div className="text-muted text-center py-3">
            <i className="bi bi-info-circle me-2"></i>
            No active alerts for this job.
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button 
          variant="warning" 
          onClick={() => setShowQAFeedback(true)}
          className="me-auto"
        >
          <i className="bi bi-clipboard-check me-2"></i>
          Submit QA Feedback
        </Button>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>

      {/* QA Feedback Modal */}
      <QAFeedback
        show={showQAFeedback}
        onHide={() => setShowQAFeedback(false)}
        job={job}
        jobId={job?.ID}
      />
    </Modal>
  );
};
AlertsModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  job: PropTypes.object,
  pumpDetails: PropTypes.array,
  noticeData: PropTypes.object,
};

export default AlertsModal;
